import PolicyDetailInfoModel from '@/dashboard/models/policys/PolicyDetailInfoModel';
import { PolicyDetailResponse, PolicyPaylodData, apiGetSwitchToAnnualPolicyDetailInfo, apiGetUpdatePolicyDetailInfo, covertFromHumpToUnderlineObj } from '@jove-frontend/uikit';
import { enableMapSet } from 'immer';
import { cloneDeep } from 'lodash';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface PolicyDetailState {
  detailInfoLoading: boolean;
  detailInfo: PolicyDetailInfoModel | null;
  updateFieldInfo: any;
  detailAllReponseInfo: PolicyDetailResponse;
}

interface PolicyDetailActions {
  commonUpdatePolicyDetailInfo: (res: any) => void;

  cleanAllPolicyDetailInfo: () => void;
  getUpdatePolicyDetailInfo: (policyId: string) => Promise<void>;
  getSwitchToAnnualPolicyDetailInfo: (policyId: string) => Promise<void>;
  updateBusinessTypeInfo: (info: { value: string; label: string }) => void;
  updateCompanyNameAndAddressInfo: (info: PolicyPaylodData) => void;
  updateBusinessActivitiesInfo: (info: { value: string; label: string }) => void;
  updateTurnoverInfo: (info: { turnover: string; turnoverRaw: string }) => void;
  updateIncomeSplitInfo: (incomeOrigin: any) => void;
  updateCoversInfo: (covers: any) => void;
  updateErnInfo: (item: any) => void;
  updateEmployeesInfo: (employeesInfo: any) => void;
  updateDetailOtherInfo: (extraParams: any) => void;
  updateContractIncomeInfo: (info: { income: number }) => void;
  updateClientNameInfo: (info: { workingCompany: string }) => void;
  updateContractPeriodInfo: (info: { projectPeriodStart: string; projectPeriodEnd: string }) => void;
  generateRequestUpdatePolicyData: () => any;
}

interface PolicyDetailStore {
  state: PolicyDetailState;
  actions: PolicyDetailActions;
}

enableMapSet();

export const usePolicyDetailStore = create<PolicyDetailStore>()(
  immer((set, get) => ({
    state: {
      detailInfo: null,
      detailAllReponseInfo: {},
      detailInfoLoading: false,
      updateFieldInfo: {},
    },
    actions: {
      // common update policy detail info
      commonUpdatePolicyDetailInfo: (res) => {
        if (res) {
          set((store) => {
            store.state.detailAllReponseInfo = res;
            const model = new PolicyDetailInfoModel();
            model.transformServeDataToInstance({
              ...res?.quotePayload,
              ...get().state.detailInfo,
            });
            store.state.detailInfo = model;
            store.state.detailInfoLoading = false;
          });
        } else {
          set((store) => {
            store.state.detailInfoLoading = false;
          });
        }
      },
      // clean all data
      cleanAllPolicyDetailInfo: async () => {
        set((store) => {
          store.state.detailInfoLoading = false;
          store.state.detailInfo = null;
          store.state.detailAllReponseInfo = {};
          store.state.updateFieldInfo = {};
        });
      },
      // get update policy detail info
      getUpdatePolicyDetailInfo: async (policy_id) => {
        set((store) => {
          store.state.detailInfoLoading = true;
        });

        const [res] = await apiGetUpdatePolicyDetailInfo({
          policy_id,
        });

        get().actions.commonUpdatePolicyDetailInfo(res);
      },
      // get switch to annual policy detail info
      getSwitchToAnnualPolicyDetailInfo: async (policy_id) => {
        set((store) => {
          store.state.detailInfoLoading = true;
        });

        const [res] = await apiGetSwitchToAnnualPolicyDetailInfo({
          policy_id,
        });

        get().actions.commonUpdatePolicyDetailInfo(res);
      },
      // update business type
      updateBusinessTypeInfo: async (info) => {
        set((store) => {
          if (store.state.detailInfo) {
            const labels = cloneDeep(get().state.detailInfo.labels);
            store.state.detailInfo.businessType = store.state.updateFieldInfo.businessType = info.value;
            store.state.detailInfo.labels = store.state.updateFieldInfo.labels = { ...labels, [info.value]: info.label };
          }
        });
      },
      // update company name and address
      updateCompanyNameAndAddressInfo: async (info: PolicyPaylodData) => {
        set((store) => {
          if (store.state.detailInfo) {
            Object.keys(info).forEach((key) => {
              store.state.detailInfo[key] = store.state.updateFieldInfo[key] = info[key];
            });
          }
        });
      },
      // update business activities
      updateBusinessActivitiesInfo: async (info) => {
        set((store) => {
          if (store.state.detailInfo) {
            const labels = cloneDeep(get().state.detailInfo.labels);
            store.state.detailInfo.businessActivity = store.state.updateFieldInfo.businessActivity = info.value;
            store.state.detailInfo.labels = store.state.updateFieldInfo.labels = { ...labels, [info.value]: info.label };
          }
        });
      },
      // update turnover
      updateTurnoverInfo: async (info) => {
        set((store) => {
          if (store.state.detailInfo) {
            store.state.detailInfo.turnover = store.state.updateFieldInfo.turnover = info.turnover;
            store.state.detailInfo.turnoverRaw = store.state.updateFieldInfo.turnoverRaw = info.turnoverRaw;
          }
        });
      },
      // update income split
      updateIncomeSplitInfo: async (incomeOrigin: any) => {
        set((store) => {
          if (store.state.detailInfo) {
            store.state.detailInfo.incomeOrigin = store.state.updateFieldInfo.incomeOrigin = incomeOrigin;
          }
        });
      },
      // update covers
      updateCoversInfo: async (covers: any) => {
        set((store) => {
          if (store.state.detailInfo) {
            store.state.detailInfo.covers = store.state.updateFieldInfo.covers = covers;
          }
        });
      },
      // update ern
      updateErnInfo: async (item: any) => {
        set((store) => {
          if (store.state.detailInfo) {
            store.state.detailInfo.ern = store.state.updateFieldInfo.ern = item?.ern;
          }
        });
      },
      // update employees
      updateEmployeesInfo: async (item: any) => {
        set((store) => {
          if (store.state.detailInfo) {
            store.state.detailInfo.elSize = store.state.updateFieldInfo.elSize = {
              clericalEmployees: item?.clerical,
              manualEmployees: item?.manual,
              totalEmployees: item?.clerical + item?.manual,
            };
          }
        });
      },

      // update other custom field
      // quoteId: reEnter confirm page, need transmit quoteId
      updateDetailOtherInfo: async (extraParams: any) => {
        if (extraParams) {
          set((store) => {
            if (store.state.detailInfo) {
              Object.keys(extraParams).forEach((key) => {
                store.state.detailInfo[key] = store.state.updateFieldInfo[key] = extraParams[key];
              });
            }
          });
        }
      },
      // update contract incom
      updateContractIncomeInfo: async (item) => {
        set((store) => {
          if (store.state.detailInfo) {
            store.state.detailInfo.income = store.state.updateFieldInfo.income = item.income;
          }
        });
      },
      // update client name
      updateClientNameInfo: async (item) => {
        set((store) => {
          if (store.state.detailInfo) {
            store.state.detailInfo.workingCompany = store.state.updateFieldInfo.workingCompany = item.workingCompany;
          }
        });
      },
      // update contract period
      updateContractPeriodInfo: async (item) => {
        set((store) => {
          if (store.state.detailInfo) {
            store.state.detailInfo.projectPeriodStart = store.state.updateFieldInfo.projectPeriodStart = item.projectPeriodStart;
            store.state.detailInfo.projectPeriodEnd = store.state.updateFieldInfo.projectPeriodEnd = item.projectPeriodEnd;
          }
        });
      },
      // get request policy update data
      generateRequestUpdatePolicyData: () => {
        // return all
        // const model = get().state.detailInfo;
        // return model.covertToServerRequestData();

        // return update field
        return covertFromHumpToUnderlineObj({ ...get().state.updateFieldInfo });
      },
    },
  }))
);
